import {
  Box,
  Grid,
  Button,
  Typography
} from "@mui/material"

import { ThemeProvider } from "@mui/material/styles"
import theme from "theme"
import GitHubIcon from "@mui/icons-material/GitHub"
import EmailRoundedIcon from "@mui/icons-material/EmailRounded"
import Header from "components/Header"
import Space from "components/Space"
import Badge from "components/Badge"

let stack = [
  "REACT",
  "NEXT.JS",
  "THEGRAPH",
  "SQL",
  "MONGODB",
  "GRAPHQL",
  "HASURA",
  "PYTHON",
  "SOLIDITY",
  "R",
  "ALCHEMY",
  "INFURA",
  "METAMASK",
  "RAINBOWKIT",
  "WAGMI.JS",
  "AWS",
  "VERCEL",
  "GITHUB"
]

const HomePage = () => {

  let date = new Date()

  return (
    <Space mt={1} ml={1} mr={1}>
      <ThemeProvider theme={theme}>
      <Space bl={4} bt={4} br={4} bb={0}>
        <Header/>

        <Space pl={2} pt={2} pr={2} pb={2}>
          <Typography variant="h4" fontFamily="Paytone One" marginBottom={2}>SERVICES</Typography>
          <Typography variant="h5" fontFamily="Space Mono">
            <Typography fontFamily="inherit" fontSize="inherit">- Distributed Web Technologies</Typography>
            <Typography fontFamily="inherit" fontSize="inherit">- Data Collection and Analytics</Typography>
            <Typography fontFamily="inherit" fontSize="inherit">- Cloud Infrastructure and Computing</Typography>
            <Typography fontFamily="inherit" fontSize="inherit">- API Development and Hosting</Typography>
            <Typography fontFamily="inherit" fontSize="inherit">- Contract Development and Audits</Typography>
            <Typography fontFamily="inherit" fontSize="inherit">- Wallet Integrations</Typography>
            <Typography fontFamily="inherit" fontSize="inherit">- Metadata Standards [721/1155/2981]</Typography>
            <Typography fontFamily="inherit" fontSize="inherit">- On-Chain Data Storage [L1/L2]</Typography>
            <Typography fontFamily="inherit" fontSize="inherit">- Decentralized Content Managment via IPFS</Typography>
            <Typography fontFamily="inherit" fontSize="inherit">- Custom Solutions</Typography>
          </Typography>
        </Space>
      </Space>
      
      <Grid container border="4px solid">
        <Grid item xs={12} sm={8}>
          <Space pl={2} pt={2} pr={2} pb={2} bl={0} bt={0} br={0}>
            <Typography variant="h4" fontFamily="Paytone One" marginBottom={2}>STACK</Typography>
            <Box display="flex-inline">
              {stack.map((x) => <Badge key={x} label={x}></Badge>)}
            </Box>
          </Space>
        </Grid>
        
        <Grid item xs={12} sm={4} sx={{backgroundColor: theme.palette.primary.main }}>
          <Space pl={2} pt={2} pr={2} pb={2} bt={4}>
            <Typography variant="h4" fontFamily="Paytone One" marginBottom={2} color={theme.palette.secondary.main}>LINKS</Typography>
            <Box marginLeft={-2} sx={{display: "inline-block"}}>
              <Button
                sx={{color: theme.palette.secondary.main, "&:hover": {color: theme.palette.secondary.dark} }}
                onClick={() => {
                  window.open("https://github.com/latent-laboratory")
                }}
                >
                <GitHubIcon fontSize="large"/>
              </Button>
            </Box>
            <Box marginLeft={-2} sx={{display: "inline-block"}}>
              <Button
                sx={{color: theme.palette.secondary.main, "&:hover": {color: theme.palette.secondary.dark} }}
                onClick={() => {
                  window.open("mailto:contact@latentlabs.xyz")
                }}
                >
                <EmailRoundedIcon fontSize="large"/>
              </Button>
            </Box>
          </Space>        
        </Grid>
      </Grid>

      <Space bl={4} br={4} bb={8}>
        <Space pl={2} pt={2} pr={2} pb={2} bl={0}>
          <Typography variant="h4" fontFamily="Paytone One" marginBottom={2}>CONTACT</Typography>
          <Typography 
            sx={{
              fontFamily: "Space Mono",
              fontSize: 20,
              maxWidth: 400
            }}>
            For general or business inquiries please reach out to{" "}
            <a href="mailto:contact@latentlabs.xyz">
              contact@latentlabs.xyz
            </a>
          </Typography>
        </Space>
      </Space>
      <Space bt={50}>
        <Box sx={{
          backgroundColor: theme.palette.primary.main,
          color: theme.palette.secondary.main,
          display: "grid",
          paddingBottom: 8,
          alignItems: "center",
          justifyContent: "center",
          fontFamily: "Space Mono", 
          fontSize: 15
        }}>
          <Box sx={{ display: "flex", justifyContent: "center"}}> 
            <img src="/media/klfiy.png" alt="" height="75px"></img>
          </Box>
          <Box sx={{display: "flex", justifyContent: "center"}}> 
            <Typography fontFamily="inherit" fontSize="inherit">
              &copy;<span>{date.getFullYear()}</span> by Latent Labs LLC
            </Typography>
          </Box>
          <Box sx={{display: "flex", justifyContent: "center"}}> 
            <Typography fontFamily="inherit" fontSize="inherit">
              All Rights Reserved
            </Typography>
          </Box>
        </Box>
      </Space>
      </ThemeProvider>
    </Space>
  )
}

export default HomePage
